/**
 * Created by IvanCai on 2017/4/24.
 */
import {Indicator, Toast} from 'mint-ui'
import {Calendar} from 'vant'
export  default {
    showLoading(text){
        Indicator.open({
            text: !text?'加载中...':text,
            spinnerType: 'fading-circle'
        });
    },
    hideLoading(){
        Indicator.close();
    },
    toast(message){
        Toast({
            message,
            duration: 1500,
            position: 'middle'
        })
    }
}
